import React from "react";
import { MainLayout } from "src/apps/commons/layouts";
import { UploadSerialNo } from "src/apps/modules/uploadData";

const Page = () => <UploadSerialNo />;
Page.Layout = MainLayout;
export default Page;
